import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { cnpj, cpf } from "cpf-cnpj-validator";

export class CpfCnpjValidator {
  static validateCpfCpnj(input: FormControl) {
    if (input.value.length === 14) {
      return cpf.isValid(input.value) ? null : { cpfInvalid: true };
    }

    if (input.value.length === 18) {
      return cnpj.isValid(input.value) ? null : { cnpjInvalid: true };
    }

    return { invalid: true };
  }
}
